/**
 * @generated SignedSource<<daa8a249cd9de5f308325977e364636b>>
 * @relayHash e3c824a9d77513f5b4acd6ae75169da0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e55691d321f37459891c5b154d29e3a1ebb1ee1f5059ad3abde8289bf4aa3a2c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardQuery } from './src_jiraBusinessBoardQuery.graphql';

import withInlineCreateMigration_provider from '@atlassian/jira-relay-provider/src/ibs-44-board-inline-create-migration.relayprovider';
import withDisplayMessage_provider from '@atlassian/jira-relay-provider/src/mbw-191-display-flags-in-case-of-no-columns.relayprovider';
import withMergedWorkflows_provider from '@atlassian/jira-relay-provider/src/merge-board-workflows.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e55691d321f37459891c5b154d29e3a1ebb1ee1f5059ad3abde8289bf4aa3a2c",
    "metadata": {},
    "name": "src_jiraBusinessBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcibs44boardinlinecreatemigrationrelayprovider": withInlineCreateMigration_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": withMergedWorkflows_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmbw191displayflagsincaseofnocolumnsrelayprovider": withDisplayMessage_provider
    }
  }
};

export default node;
